<template lang="pug">
  .component-reveal-driver-flag
    ModalReveal
      button.button.danger(slot="trigger") Add flag

      array-edit(:options="extras", :values="body.flags")
      ActionButton(slot="footer" :action="add", :disabled="Object.keys(body.flags).length === 0") Add

</template>
<script type="text/babel">
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import ActionButton from '../../ActionButton'
import Transaction from '../../../../backoffice/Transaction'
import BaseList from '../../../../../pages/backoffice/BaseList'
import ArrayEdit from "../../ArrayEdit.vue";
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";
import {EventBus} from "../../../../../eventBus";

export default {
  name: 'AddDriverFlagReveal',
  components: {ArrayEdit, BaseList, Transaction, ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      body: {
        flags: {}
      },
      extras: [
        {
          "Verification": [
            {
              "kyc_requested": "Kyc verification"
            }
          ]
        }
      ]
    }
  },
  methods: {
    add() {
      return KeplerBackofficeSdk.drivers.select(this.item).setFlags(this.body, () => {
        MaggieHelper.notification("flag", "Flag set")
        EventBus.$emit('close-modal')
      })
    }
  },
  props: ['item'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reveal-void
  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// AddDriverFlagReveal.vue?2ae9afa3